<template>
  <div class="join-steps">
    <!-- Steps BG – Unused -->
    <!-- <div class="join-step-bg">
      <img src="/figures/join-steps-bg.png" />
    </div> -->
    <!-- Steps list -->
    <div class="join-step-list">
      <div class="join-step join-step--1">
        <div class="join-step-pulse">
          <div class="join-step-pulse-glowbe">
            <Glowbe :pulse="true" />
          </div>
        </div>
        <p><a href="/waitlist"><span class="gray">Fill out</span> the waitlist<span class="arrow-right"><img src="/figures/arrow-right-medium.svg"/></span></a></p>
      </div>
      <div class="join-step join-step--2">
        <div class="join-step-pulse">
          <div class="join-step-pulse-glowbe">
            <Glowbe :pulse="true" />
          </div>
        </div>
        <p><a href="https://buy.usb.club/products/sample-8" target="_blank"><span class="gray">Buy a USB Club USB in </span> the shop<span class="arrow-right"><img src="/figures/arrow-right-medium.svg"/></span></a></p>
      </div>
      <div class="join-step join-step--3">
        <div class="join-step-pulse">
          <div class="join-step-pulse-glowbe">
            <Glowbe :pulse="true" />
          </div>
        </div>
        <p>Schedule a 1-1 onboarding.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Glowbe from "./Glowbe.vue";

export default {
  name: "JoinSteps",
  components: {
    Glowbe,
  },
};
</script>

<style>
.join-steps {
  display: flex;
  position: relative;
  width: 100%;
  margin-top: 6.4rem;
}

.join-step-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 8rem;
  z-index: 0;
  margin-left: 4rem;
}

.join-step-bg img {
  width: 100%;
}

.join-step-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
  z-index: 10;
  margin-left: 4rem;
}

.join-step-list p {
  font-size: 2.4rem;
  font-family: "ISO", monospace;
  line-height: 150%;
}

.join-step {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.join-step-pulse {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 8rem;
  width: 8rem;
  /* margin-right: 2.4rem; */
}

.join-steps p {
  color: rgba(255,255,255,0.75);
}

.join-steps p a {
  color: #ffffff;
  text-decoration: none;
}

.join-steps p a span.gray {
  color: rgba(255,255,255,0.75);
  transition: all 150ms ease-in-out;
}

.join-steps a span.arrow-right {
  display: inline-block;
  margin-left: 8px;
  transition: all 150ms ease-in-out;
}

.join-steps a:hover span.arrow-right {
  transform: translateX(5px);
}

.join-steps a:hover span.gray {
  color: #ffffff;
}

@media screen and (max-width: 700px){

  .join-steps {
    margin-top: 0;
  }

  .join-step-bg {
    width: 5.2rem;
  }

  .join-step {
    margin-bottom: 0.8rem;
  }

  .join-step-pulse { 
    width: 4rem;
    height: 4rem;
  }

  .join-step-pulse {
    margin-right: 0.8rem;
  }

  .join-step-pulse-glowbe {
    transform-origin: center center;
    transform: scale(0.75);
  }

  .join-step-list p {
    font-size: 1.6rem;
  }

  .join-step-list {
    margin-left: 0;
  }

  .join-steps a span.arrow-right {
    margin-left: 4px;
    width: 12px;
  }
}
</style>
